import { Link } from "react-router";
import { MailCheck } from "lucide-react";

export default function CheckYourEmail() {
  return (
    <div className="text-center">
      <div className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
        <MailCheck className="h-7 w-7" />
      </div>
      <h1 className="text-3xl font-extrabold leading-tight tracking-tight">
        Revisa tu correo
      </h1>
      {/* Genérico a propósito: lo usan el registro y el reset de contraseña. */}
      <p className="mt-2 text-sm text-muted-foreground">
        Te enviamos un enlace a tu correo. Si no lo encuentras, revisa tu
        carpeta de spam.
      </p>
      <Link
        to="/auth/login"
        className="mt-8 inline-block text-sm font-medium text-primary hover:underline"
      >
        Volver a Iniciar Sesión
      </Link>
    </div>
  );
}
